// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__18BnM","signatureButtonsRight":"ModalSign_signatureButtonsRight__1UyFd"};